

<template>
  <div>
    <b-card class="mt-3">
      <b-card-title class="text-primary ml-2 mr-2 d-inline">
        <h3>Relatório de falhas</h3>
      </b-card-title>
      <b-card-body>
        <b-row align-v="end" class="mt-2">
          <b-col class="col-md-2">
            <label for="statu">Status</label>
            <b-form-select
              size="sm"
              id="statu"
              v-model="status"
              :options="options"
            ></b-form-select>
          </b-col>
          <b-col class="col-md-2">
            <label for="rev">Revendedora</label>
            <b-form-input
              size="sm"
              autofocus
              id="rev"
              v-model="revend"
              placeholder="Maria da Silva"
            ></b-form-input>
          </b-col>
          <b-col class="col-md-2">
            <label for="in">Início</label>
            <b-form-datepicker
              id="in"
              placeholder="Nenhuma Data"
              calendar-width="200"
              label-no-date-selected=""
              label-next-month="Próximo Mês"
              label-next-year="Próximo Ano"
              label-prev-month="Mês Anterior"
              label-prev-year="Ano Anterior"
              label-current-month="Mês Atual"
              label-help
              hide-header
              size="sm"
              v-model="inicio"
              :date-format-options="{
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
              }"
              locale="pt-BR"
            >
            </b-form-datepicker>
          </b-col>
          <b-col class="col-md-2">
            <label for="fi">Fim</label>
            <b-form-datepicker
              id="fi"
              placeholder="Nenhuma Data"
              calendar-width="200"
              label-no-date-selected=""
              label-next-month="Próximo Mês"
              label-next-year="Próximo Ano"
              label-prev-month="Mês Anterior"
              label-prev-year="Ano Anterior"
              label-current-month="Mês Atual"
              label-help
              hover
              hide-header             
              size="sm"
              v-model="fim"
              :date-format-options="{
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
              }"
              locale="pt-BR"
            >
            </b-form-datepicker>
          </b-col>
          <b-col>
            <b-button size="sm" variant="primary" @click="buscar()">
              <b-spinner small label="Loading..." v-if="loading"></b-spinner>
              Buscar
            </b-button>
          </b-col>
          <b-col class="text-right">
            <b-button variant="success" size="sm" @click="exportar">
              <i class="far fa-file-excel"></i> Exportar</b-button
            >
          </b-col>
          <!-- <b-col>
                       <json-excel :fields="json_fields" :data="revendedoras" v-if="revendedoras.length > 0" worksheet="Revendedoras" :name="showFilename">
                           <b-button variant="success" size="sm"> <i class="far fa-file-excel"></i> Exportar</b-button>
                        </json-excel>
                    </b-col> -->
        </b-row>
        <b-row class="mt-3">
          <b-table
            :items="revendedoras"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            :sort-by.sync="sortBy"
            stacked="md"
            show-empty
            empty-text="Nenhuma Revendedora Encontrada!"
            responsive
            striped
            small
          >
            <template #table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Listando Revendedoras ...</strong>
              </div>
            </template>
            <template #cell(ativa)="row">
              <b-badge v-if="row.item.ativa == true" variant="success"
                >Ativa</b-badge
              >
              <b-badge v-else variant="danger">Inativa</b-badge>
            </template>
          </b-table>
        </b-row>
        <b-row align-h="end" v-if="revendedoras.length > 0">
          <b-col class="md-8">
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              align="fill"
              size="sm"
              class="my-0"
            ></b-pagination>
          </b-col>
          <b-col class="text-right">
            Total de Registros: {{ revendedoras.length }}
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
  </div>
</template>


<script>
import JsonExcel from "vue-json-excel";
export default {
  props: [],

  name: "relatorio-falha",
  components: {
    JsonExcel,
  },
  data() {
    return {
      json_fields: {
        Revendedora: "nome",
        Status: "ativa",
        "E-mail": "email",
        Desconto: "desconto",
      },

      datePickerConfig: {
        format: "D/MM/YYYY",
        showClose: true,
      },
      options: [
        { value: "todos", text: "Todos" },
        { value: "true", text: "Ativo" },
        { value: "false", text: "Inativo" },
      ],
      inicio: moment().subtract(3, "months").format("YYYY-MM-d"),
      fim: moment().format("YYYY-MM-d"),
      status: "todos",
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      sortBy: "nome",
      revend: "",
      revendedoras: [],
      fields: [
        {
          key: "nome",
          label: "Revendedora",
          sortable: true,
        },
        {
          key: "ativa",
          label: "Status",
          sortable: true,
        },
        {
          key: "email",
          label: "E-mail",
        },
        {
          key: "desconto",
          label: "Desconto",
          sortable: true,
        },
      ],
      loading: false,
      dateDisabled: {
        from: new Date(),
      },
    };
  },
  methods: {
    exportExcel() {
      $(".loading").show();
    },

    finishExcel() {
      $(".loading").hide();
    },
    buscar() {
      const vm = this;
      vm.revendedoras = [];
      if (
        vm.inicio === "" ||
        vm.inicio === null ||
        vm.fim === "" ||
        vm.fim === null
      ) {
        return vm.$swal("Ops!", "Informe as datas de início e fim", "error");
      }
      if (vm.inicio > vm.fim) {
        return vm.$swal(
          "Ops!",
          "A data de inicio não pode ser maior que a data fim",
          "error"
        );
      }
      vm.loading = true;
      const params = {
        status: vm.status,
        revendedora: vm.revend ? vm.revend : "",
        inicio: vm.inicio,
        fim: vm.fim,
      };
      axios
        .get("/distribuidor/relatorio/relatoriofalha", { params: params })
        .then((response) => {
          vm.revendedoras = response.data.revendedoras;
          vm.totalRows = vm.revendedoras.length;
        })
        .catch((erro) => {
          console.log(erro);
        })
        .finally(() => {
          vm.loading = false;
        });
    },
    exportar() {
      const vm = this;
      const params = {
        status: vm.status,
        revendedora: vm.revend ? vm.revend : "",
        inicio: vm.inicio,
        fim: vm.fim,
      };

      $(".loading").show();
      axios
        .get("/distribuidor/relatorio/get-exportar-falha", { params: params })
        .then((response) => {
          window.open("/distribuidor/relatorio/exportar-falha/" + response.data.resource, '_blank');
        })
        .catch((erro) => {
          console.log(erro);
        })
        .finally(() => {
          $(".loading").hide();
        });
    },
  },
  computed: {
    showFilename() {
      return new Date().getTime() + ".xls";
    },
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/distribuidor/relatorio/Falha.vue